import '../css/app.css';

import './components/consentCookieCleanup.js';
import './components/nav.js';
import './components/formieDatePicker.js';

// Swiper (slider/gallery/newsFeed/homesSlider/testimonialsFeed) and Video.js
// (video) are only fetched on pages that actually contain that block, rather
// than bundled into every page load.
if (document.querySelector('[data-slider]')) {
    import('./components/slider.js');
}
if (document.querySelector('[data-gallery]')) {
    import('./components/gallery.js');
}
if (document.querySelector('[data-news-feed]')) {
    import('./components/newsFeed.js');
}
if (document.querySelector('[data-homes-slider]')) {
    import('./components/homesSlider.js');
}
if (document.querySelector('[data-testimonials-feed]')) {
    import('./components/testimonialsFeed.js');
}
if (document.querySelector('[data-video-player]')) {
    import('./components/video.js');
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)

// Accordion behaviour for _blocks/accordion.twig. `allowMultiple` comes from
// the block's `allowMultipleOpen` lightswitch, so an editor decides whether
// panels behave as a set of toggles or as a single-open accordion.
Alpine.data('accordion', (allowMultiple = false) => ({
    open: [],

    isOpen(index) {
        return this.open.includes(index)
    },

    toggle(index) {
        if (this.isOpen(index)) {
            this.open = this.open.filter((i) => i !== index)

            return
        }

        this.open = allowMultiple ? [...this.open, index] : [index]
    },
}))

window.Alpine = Alpine
Alpine.start()
